import axios from 'axios';
import API_URL from '../config/api';

let cachedProjects = null;
export const getCachedProjects = () => cachedProjects;

function retryDelay(signal) {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) return reject(new axios.CanceledError());
    const timer = setTimeout(() => {
      signal?.removeEventListener('abort', cancel);
      resolve();
    }, 700);
    const cancel = () => {
      clearTimeout(timer);
      signal?.removeEventListener('abort', cancel);
      reject(new axios.CanceledError());
    };
    signal?.addEventListener('abort', cancel, { once: true });
  });
}

export async function getProjects(signal) {
  for (let attempt = 0; attempt < 2; attempt += 1) {
    try {
      const response = await axios.get(`${API_URL.replace(/\/$/, '')}/trabajos`, {
        timeout: 12000,
        signal
      });
      if (!Array.isArray(response.data) || !response.data.every(project => project && typeof project._id === 'string' && typeof project.nombre === 'string')) {
        throw new Error('Invalid projects response');
      }
      if (signal?.aborted) throw new axios.CanceledError();
      cachedProjects = response.data;
      return response.data;
    } catch (error) {
      const retryable = !error.response || [429, 500, 502, 503, 504].includes(error.response.status);
      if (signal?.aborted || axios.isCancel(error) || attempt === 1 || !retryable || !axios.isAxiosError(error)) throw error;
      await retryDelay(signal);
    }
  }
}
